/* unplugin-vue-components disabled */import { render } from "./OpenQuestionQuiz.vue?vue&type=template&id=7cb741c4&scoped=true&ts=true"
import script from "./OpenQuestionQuiz.vue?vue&type=script&lang=ts"
export * from "./OpenQuestionQuiz.vue?vue&type=script&lang=ts"

import "./OpenQuestionQuiz.vue?vue&type=style&index=0&id=7cb741c4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cb741c4"]])

export default __exports__